import type { ComponentProps } from 'react';
import { Button, Spinner, cn } from '@/lib/macondo';

type BtnProps = ComponentProps<typeof Button> & {
  /** Request in flight: shows a spinner before the label, disables the button and sets aria-busy. */
  loading?: boolean;
};

/** Macondo Button with the portal defaults: 14px label (Macondo's 12px is small for customers) and a 44 px minimum target. */
export function Btn({ className, loading = false, disabled, children, ...props }: BtnProps) {
  return (
    <Button
      className={cn('text-callout-medium min-h-[44px]', loading && 'gap-200', className)}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      {...props}
    >
      {loading && <Spinner className="size-400 shrink-0" aria-hidden="true" data-testid="btn-spinner" />}
      {children}
    </Button>
  );
}
